module.exports = __webpack_public_path__ + "img/workshops.cddbe29a.svg";